















import { Storage, Constants } from '@/services'

export default {
  name: 'VerifyEmail',

  methods: {
    toUrl() {
      const offerFilterAddress = Storage.getItem(Constants.OFFER_FILTER_ADDRESS)
      if (offerFilterAddress) {
        return `/?address=${encodeURIComponent(offerFilterAddress)}`
      }

      return '/'
    },
  },
}
